import "jquery.fancytree";
import "jquery.fancytree/dist/modules/jquery.fancytree.edit";
import "jquery.fancytree/dist/modules/jquery.fancytree.persist";
import Tabs from "./tabs";
import { HB } from "./utils";

const tree = (function() {
  /**
   * @function Tree
   */
  function Tree() {
    this.init();
  }

  Tree.$elem = $elem => $elem || $("#tree-pane-component");

  Tree.prototype.init = function() {
    let notification = CodeEditor.UI.notif();
    let validFilename = require("./utils").validFilename;
    return $.ajax({
      cache: false,
      url: CodeEditor.Tree.treeEndPoint(),
      success: function(data) {
        Tree.updateFileList();
        const _tree = data.tree;
        console.log(_tree);
        Tree.$elem().fancytree({
          source: _tree,
          autoScroll: true,
          extensions: ["edit", "persist"],
          persist: {
            store: "local"
          },
          checkbox: false,
          selectMode: 2,
          edit: {
            triggerStart: null,
            edit: (event, { isNew, node }) => {
              if (isNew) node.editEnd(true);
            },
            save: async (event, { node, dirty, input, orgTitle, isNew }) => {
              if (dirty && !validFilename(input.val())) {
                notification.error({
                  message: `filename must be of valid format! <b>${input.val()}</b> is not valid!`
                });
                node.editEnd(false);
                return false;
              }
              let content = node.data.original_content ? node.data.original_content : "";
              const { success } = await CodeEditor.Main.saveFile(node, input.val(), content, true, orgTitle);
              if (success && isNew) CodeEditor.Tree.openFile(null, node);
              const targetTab = Tabs.getTabByKey(node.key);
              if (targetTab) {
                targetTab.setTitle(node.title);
                targetTab.config.node = node;
              }
            }
          },
          dblclick: Tree.openFile,
          keydown: function(event, data) {
            let input = String.fromCharCode(event.keyCode).toLowerCase();
            if (event.which === 78 && event.altKey === true) {
              Tree.createNode(data.node);
              return false;
            }
            if (event.which === 46 && $(".tingle-modal--visible").length === 0) {
              CodeEditor.ContextMenu.deleteElement(data.node);
              return false;
            }
            if (event.which === 13 && $(".tingle-modal--visible").length === 0) {
              Tree.openFile(event, data);
            }
            if (/[a-zA-Z0-9-_]/.test(input)) {
              let activeNode = window.tree.getActiveNode();
              let activeNodeSiblings = activeNode.parent.children;
              let currentIndex = activeNodeSiblings.findIndex(i => i.key == activeNode.key);
              let node = activeNodeSiblings
                .slice(currentIndex + 1)
                .find(({ title }) => (title[0] === "_" ? title.slice(1) : title).toLowerCase()[0] === input);
              if (node) {
                node.setActive();
              } else {
                node = activeNodeSiblings.find(i => i.title.toLowerCase().indexOf(input) == 0);
                if (node) {
                  node.setActive();
                }
              }
            }
          },
          modifyChild: () => {},
          renderNode: (event, data) => {
            const node = data.node;
            node.folder && $(node.li).addClass("ixcanul-tree-folder my test");
            if (node.title == "builder.config.json") node.span.dataset.icon = "gear";
          }
        });
        const tree = $.ui.fancytree.getTree("#tree-pane-component");
        window.tree = tree;
        const faviconNode = tree.findFirst(n => n.title === "favicon.png");
        if (faviconNode) {
          const faviconUrl = faviconNode ? faviconNode.data.image_url : false;
          CodeEditor.Main.loadFavicon(faviconUrl);
        }

        CodeEditor.Tree.openRecentTabs();

        $("#tree-pane-component .image-upload")
          .parent()
          .addClass("image-upload-parent");

        // return window.tree.getRootNode().sortChildren(null, true);
        // trigger a click to activate a tree node and attatch CM to it
        $(document.body).on("mousedown.CM", ".fancytree-node", function(e) {
          e.which === 3 && $(this).trigger("click");
        });
        $(document.body).on("contextmenu:focus", ".context-menu-item", function(e) {
          console.log("focused");
          e.which === 3 && $(this).trigger("click");
        });
        Tree.assignTephraFolders();
        window.tree.getSelectedNodes().forEach(i => {
          i.toggleSelected();
          i.selected = false;
        }); // unselected any selected nodes
        // init the dnd on the tree
        // CodeEditor.ContextMenu.bulkActions()
        loadBulkClasses();
        return CodeEditor.Main.orderFoldersFirst(window.tree.getRootNode(), null, true);
      }
    });
  };

  Tree.treeEndPoint = function() {
    return "/api/v1/code_editor/tree.json?theme_id=" + CodeEditor.Main.themeId() + "&t=" + Date.now();
  };

  Tree.getNodePath = node => {
    let path;
    if (typeof node != "undefined") {
      path = node.title;
      if (node.parent.title !== "root") {
        path = CodeEditor.Tree.getNodePath(node.parent) + "/" + path;
      }
      return path;
    }
    return false;
  };

  /**
   * Finds a targetted node on the tree by providing a context for the required node
   * @function findNodeByContext
   * @param {object} triggerNode an object representing a node on the file tree or the required fields in the save api
   * @return {object} node a single node from the tree as a fancyTree object
   */
  Tree.findNodeByContext = triggerNode => {
    triggerNode.classList.add("trigger-node");
    let _nodeFinderCallback = node =>
      node.span && (node.span.classList.contains("trigger-node") || node.li.classList.contains("trigger-node"));
    let node = window.tree.findFirst(_nodeFinderCallback);
    if (node !== null) {
      node.setActive().then(() => {
        $(triggerNode).removeClass("trigger-node");
      });
    } else {
      node = window.tree.getActiveNode();
      $(triggerNode).removeClass("trigger-node");
    }
    return node;
  };

  Tree.openFile = async (event, data, callback) => {
    let node;
    let node_path;
    let returnVal;
    node = typeof data.node !== "undefined" ? data.node : data;
    node_path = Tree.getNodePath(node);
    // exit if it's a folder
    if (node.folder) return;
    if (typeof selectedNode !== "undefined" && selectedNode != null) {
      selectedNode.toggleSelected();
    }
    window.selectedNode = node;
    // mark as selected
    selectedNode.toggleSelected();
    //  load the file
    if (document.getElementById(node_path) != null) {
      Tabs.setActiveById(node_path);
      if (typeof callback === "function") {
        callback();
      }
    } else if (document.getElementById("file-" + node.data.secure_random)) {
      Tabs.setActiveById(node.data.secure_random);
      if (typeof callback === "function") {
        callback();
      }
    } else {
      returnVal = CodeEditor.Main.loadFile(
        node,
        node.data.file_type,
        node_path,
        typeof callback === "function" ? callback : null
      );
    }
    let expandParents = () => {
      let parents = selectedNode.getParentList().reverse();
      let timeout = () => {
        setTimeout(function() {
          let parent = parents.pop();
          if (typeof parent !== "undefined") parent.setExpanded(true);
          else return true;
          timeout();
        }, 300);
      };
      return timeout();
    };
    expandParents();
    return returnVal;
  };

  Tree.reload = () => {
    const JSONSource = CodeEditor.Tree.treeEndPoint();
    const existingContents = window.tree.findAll(node => node.data.content);
    let json = $.getJSON(JSONSource);
    return json.done(data => {
      window.tree.reload(data.tree);
      Tree.updateFileList();
      CodeEditor.Main.orderFoldersFirst(window.tree.getRootNode(), null, true);
      loadBulkClasses();
      existingContents.forEach(({ data, key }) => {
        const { content } = data;
        const targetNode = window.tree.getNodeByKey(key);
        targetNode.data.content = content;
      });

      if (window.SelectedNode) {
        Tree.selectNode(window.SelectedNode.key);
      }
    });
  };

  Tree.deselectAllNodes = () => {
    if (window.tree.getSelectedNodes()) {
      window.tree.getSelectedNodes().forEach(i => i.setSelected(false));
    }
  };

  Tree.updateFileList = () => {
    const json = $.getJSON(
      `/api/v1/code_editor/files.json?theme_id=${CodeEditor.Main.themeId()}&socket_id=${window.socketId}`
    );
    json.done(data => {
      const fileList = data
        .filter(f => !f.folder)
        .map(({ secure_random, id, reference, asset_type, path }) => {
          return { secure_random, id, reference, asset_type, path };
        });
      localStorage.setItem("files_list", JSON.stringify(fileList));
    });
  };

  Tree.selectNode = key => {
    Tree.deselectAllNodes();
    let node = window.tree.findFirst(i => !i.folder && (i.key === String(key) || i.data?.secure_random === key));

    if (node) {
      node.setSelected();
      selectedNode = node;
    } else {
      console.log("FAIL!!");
      HB.notify({
        message: "selectedNode is null!",
        context: {
          nodeKey: key,
          themeId: CodeEditor.Main.themeId(),
          activeNode: window.tree.getActiveNode().data
        }
      });
    }
  };
  Tree.openRecentTabs = () => {
    if (document.hidden) {
      const visibilityHandler = () => {
        if (!document.hidden) {
          Tabs.recentTabs();
          document.removeEventListener("visibilitychange", visibilityHandler);
        }
      };
      document.addEventListener("visibilitychange", visibilityHandler);
    } else {
      Tabs.recentTabs();
    }
  };
  /**
   * @function prototype.removeDuplicates
   * @return {undefined} {description}
   */
  Tree.prototype.removeDuplicates = function() {
    $.getJSON(CodeEditor.Tree.treeEndPoint(), function(data) {
      let d = data.tree[0].children;
      uniq(d);
    });
    /**
     * @function uniq
     * @param  {type} jo {description}
     */
    function uniq(jo) {
      let duplicates = [];
      let dups = dupCheck(jo, duplicates);
      if (dups.length > 0) {
        console.warn("duplicates registered!", "removing duplicate files...");
        $.ajax({
          type: "delete",
          url: "/api/v1/code_editor/batch_destroy",
          data: {
            files: dups,
            theme_id: CodeEditor.Main.themeId(),
            socket_id: window.socketId
          },
          success: function() {
            console.log("files deleted successfully");
            Tree.reload();
          },
          error: function(xhr, ajaxOptions, thrownError) {
            console.log(thrownError);
            Tree.reload();
          }
        });
      }
      /**
       * @function dupCheck
       * @param  {type} idx   {description}
       * @param  {type} array {description}
       * @return {type} {description}
       */
      function dupCheck(idx, array) {
        idx.sort((a, b) => a.folder - b.folder);
        let uniquefiles = [...new Set(idx.map(a => a.folder === false && a.title).filter(a => typeof a === "string"))];
        let uniquefolders = [...new Set(idx.map(a => a.folder && a.title).filter(a => typeof a === "string"))];
        idx.forEach(function(i) {
          if (i.folder && i.key !== "tephra") {
            if (uniquefolders.includes(i.title)) {
              uniquefolders = uniquefolders.filter(f => f !== i.title);
            } else {
              console.error(i.title + " folder is a duplicate with key " + i.key);
              duplicates.push({ id: i.key, file_type: i.file_type });
            }
          } else if (i.folder === false) {
            if (uniquefiles.includes(i.title)) {
              uniquefiles = uniquefiles.filter(f => f !== i.title);
            } else {
              console.error(i.title + " file is a duplicate with key " + i.key);
              duplicates.push({ id: i.secure_random, file_type: i.file_type });
            }
          }
          if (i.key !== "tephra" && Array.isArray(i.children) && i.children.length > 0) {
            dupCheck(i.children, array);
          }
        });
        return duplicates;
      }
    }
  };

  /**
   * @function Tree.createNode
   * @param  {NodeObject} parentNode {description}
   * @param  {Object} newNode  {description}
   */
  Tree.createNode = (parentNode, newNode) => {
    let file_type = CodeEditor.Main.fileType(parentNode);
    $(document.body).focus();

    const _createFile = async () => {
      if (parentNode.folder) {
        const newFile = await CodeEditor.ContextMenu.createFile(parentNode, file_type, newNode);
        console.log({ newFile, newNode });
      } else {
        const newFile = await CodeEditor.Main.createFile(newNode);
        console.log({ newFile, newNode });
        // CodeEditor.ContextMenu.createFile(parentNode.parent, file_type, newNode);
      }
      Tree.prototype.removeDuplicates();
    };

    _createFile();
  };

  Tree.getNodeByPath = function(path) {
    return window.tree.findFirst(node => node.data.path === path);
  };
  Tree.getFolderByPath = path => {
    return window.tree.findFirst(
      node =>
        (node.folder && node.data.path === path) ||
        node.data.path === path + "/" ||
        node.data.path === (path.endsWith("/") ? path.slice(0, -1) : false)
    );
  };
  /**
   * Find if a node or a path string represents a node in the tree
   * @function Tree.nodeExists
   * @param  {Object/String} node an object that contains a path property or a string that represents the path
   * @return {boolean}
   */
  Tree.nodeExists = node => {
    if (typeof node === "string" && CodeEditor.Tree.getNodeByPath(node)) {
      return true;
    } else if (typeof node === "object") {
      if (node.data && node.data.path) {
        return CodeEditor.Main.nodeExists(node.data.path);
      } else if (node.path) {
        return CodeEditor.Main.nodeExists(node.path);
      }
    }
    return false;
  };

  /**
   * Find a node in the tree with a tree node object
   * @function Tree.findNode
   * @param  {Object} node a fancyTree node object
   * @return {Object} if not found the function will return null
   */
  Tree.findNode = node => {
    return window.tree.findFirst(item => item === node);
  };
  Tree.assignTephraFolders = () => {
    return window.tree
      .findAll(node => node.key === "tephra" || (node.folder && node.data && node.data.tephra && node.li))
      .forEach(node => node.li.classList.add("tephra-node"));
  };

  function loadBulkClasses() {
    window.tree
      .findAll(i => !i.data.tephra && !i.children && !i.folder && i.li)
      .forEach(i => i.li.classList.add("selectable_ready"));
  }

  return Tree;
})();

export default tree;
